export default __webpack_public_path__ + "static/media/levelwise_account.82931d02.svg";